import { apiClient } from "./apiClient";

export const feedingsApi = {
  listCatalog: () => apiClient.get("/feedings").then((r) => r.data),
  log: (hiveId, payload) => apiClient.post(`/hives/${hiveId}/feeding`, payload).then((r) => r.data),
};
